import { userService } from '../_services';

export const users = {
    namespaced: true,
    state: {
        all: {},
        role: null,
    },
    actions: {
        getAll({ commit }) {
            commit('getAllRequest');

            userService.getAll()
                .then(
                    users => commit('getAllSuccess', users),
                    error => commit('getAllFailure', error)
                );
        },
        getRole({commit}) {
            userService.getRole()
                .then(
                    role => commit('getRoleSuccess', role),
                    error => commit('getRoleFailure', error)
                );
        }
    },
    mutations: {
        getAllRequest(state) {
            state.all = { loading: true };
        },
        getAllSuccess(state, users) {
            state.all = { items: users };
        },
        getAllFailure(state, error) {
            state.all = { error };
        },
        getRoleSuccess(state, role) {
            state.role = role;
        },
        getRoleFailure(state, error) {
            state.role = { error };
        }
    }
}
